module.exports = __webpack_public_path__ + "static/media/telephone.1f7931d0.svg";